import React from "react";
import { Drawer, List, Divider } from "@material-ui/core";
import cocLogo from "../../../images/cosmos-offer-club-logo.png";
import CloseIcon from "@material-ui/icons/Close";
import NavigationDrawerItem from "./nav_drawer_item/NavigationDrawerItem";
import homeIcon from "../../../images/home-icon.svg";
import allProductsIcon from "../../../images/all-products-icon.svg";
import promoCodesIcon from "../../../images/promo-codes-icon.svg";
import hotDealsIcon from "../../../images/hot-deals-icon.svg";
import contactUsIcon from "../../../images/contact-us-icon.svg";
import privacyPolicyIcon from "../../../images/privacy-policy-icon.svg";
import facebookIcon from "../../../images/facebook-icon.png";
import useStyles from "./styles";

function NavigationDrawer({ open, onClose }) {
  const classes = useStyles();

  return (
    <Drawer open={open} onClose={onClose}>
      <div className={classes.navDrawerHeader}>
        <img src={cocLogo} alt="" width={275} height={55} />
        <CloseIcon style={{ cursor: "pointer" }} onClick={onClose} />
      </div>
      <div className={classes.navContent}>
        <Divider />
        <List>
          <NavigationDrawerItem
            itemName="Home"
            itemIcon={homeIcon}
            redirectLink="/"
            onClick={onClose}
          />
        </List>
        <Divider />
        <List>
          <NavigationDrawerItem
            itemName="Show all products"
            itemIcon={allProductsIcon}
            onClick={onClose}
            redirectLink="/products"
          />
        </List>
        <Divider />
        <List>
          <NavigationDrawerItem
            itemName="Hot deals"
            itemIcon={hotDealsIcon}
            onClick={onClose}
            redirectLink="/hotdeals"
          />
          <NavigationDrawerItem
            itemName="Promo codes"
            itemIcon={promoCodesIcon}
            onClick={onClose}
            redirectLink="/promocodes"
          />
        </List>
        <Divider />
        <List>
          <NavigationDrawerItem
            itemName="Contact us"
            itemIcon={contactUsIcon}
            onClick={onClose}
            redirectLink="/contact"
          />
          <NavigationDrawerItem
            itemName="Privacy policy"
            itemIcon={privacyPolicyIcon}
            onClick={onClose}
            redirectLink="/privacypolicy"
          />
        </List>
        <Divider />
        <List>
          <NavigationDrawerItem
            itemName="Find us on Facebook"
            itemIcon={facebookIcon}
            onClick={() =>
              window.open("https://www.facebook.com/cosmosofferclub")
            }
          />
        </List>
      </div>
    </Drawer>
  );
}

export default NavigationDrawer;
